import {
    Box,
    Button,
    Container,
    FormHelperText,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Config from "Config";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getUserAgent, isEmpty, isNotEmpty } from "../../Utils";
import Header from "../../component/Header/Header";
import PortalNavbar from "../../component/PortalNavbar/PortalNavbar";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import {
    getOTP,
    publicUserLogin,
    setPublicResetPasswordTime,
} from "../../redux/action";
import { getToken } from "../../redux/selector";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
import IamsmartLoginButton from "../IamsmartLoginButton/IamsmartLoginButton";
import "./LoginPage.scss";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    eye: {
        transform: "translate(10px)",
    },
});

function LoginPublic() {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();
    const [cookies, setCookie] = useCookies(["token"]);
    const token = useSelector(getToken());
    const navigate = useNavigate();
    const onFetchError = () => {
        setError("password", {
            type: "invalid",
            message: t(`errorMsg.login.invalid`),
        });
    };

    useEffect(() => {
        // when login success
        if (isNotEmpty(token)) {
            setCookie("token", token, {
                path: `${Config.CONTENT_PATH}`,
                maxAge: 3600,
                secure: true,
            });
        }
    }, [token]);

    const { register, handleSubmit, watch, formState, setError } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
        mode: "onBlur",
    });

    const [isGenOTP, setIsGenOTP] = useState(false);
    const [otpMsg, setOtpMsg] = useState("");
    const [loginMsg, setLoginMsg] = useState("");
    const [actionType, setActionType] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const redirect = searchParams.get("redirect");

    const publicResetPassWordTime = useSelector(
        (state) => state.publicResetPassWordTime
    );
    const [otpButtonDisabled, setOtpButtonDisabled] = useState(false);
    const [countdown, setCountdown] = useState(0);

    const calculateWithin60Seconds = () => {
        if (!publicResetPassWordTime) return false;
        const currentTime = new Date().getTime();
        const timeDiff = Math.floor(
            (currentTime - publicResetPassWordTime) / 1000
        );
        return timeDiff <= 60;
    };

    useEffect(() => {
        if (publicResetPassWordTime && calculateWithin60Seconds()) {
            setOtpButtonDisabled(true);
            const timePassed = Math.floor(
                (new Date().getTime() - publicResetPassWordTime) / 1000
            );
            setCountdown(60 - timePassed);

            const interval = setInterval(() => {
                const timeDiff = Math.floor(
                    (new Date().getTime() - publicResetPassWordTime) / 1000
                );
                const remainingTime = 60 - timeDiff;

                if (remainingTime > 0) {
                    setCountdown(remainingTime);
                } else {
                    setCountdown(0);
                    setOtpButtonDisabled(false);
                    clearInterval(interval);
                }
            }, 1000);

            return () => {
                clearInterval(interval);
            };
        }
    }, [publicResetPassWordTime]);

    const onLogin = () => {
        if (isEmpty(redirect)) {
            navigate("/main");
        } else {
            navigate(redirect);
        }
    };

    const onSubmit = (data) => {
        window.grecaptcha.ready(function () {
            window.grecaptcha
                .execute("6LeWvVwdAAAAAI9JwB5OcndiYHiCA_LCISNCmTiM", {
                    action: "submit",
                })
                .then(function (token) {
                    let formData = new FormData();
                    formData.append("email", data?.email);
                    formData.append("password", data?.password);
                    formData.append("response", token);
                    // Send form value as well as token to the server
                    if (actionType === "Login") {
                        if (data?.password === "") {
                            setLoginMsg("MISSING_PASSWORD");
                        } else {
                            dispatch(
                                publicUserLogin(formData, onFetchError)
                            ).then((result) => {
                                let msg = result?.msg;
                                let token = result?.token;
                                if (msg == "SUCCESS" && token != null) {
                                    setLoginMsg(msg);
                                    onLogin();
                                } else {
                                    setLoginMsg(msg);
                                }
                            });
                        }
                    } else {
                        dispatch(getOTP(formData, onFetchError)).then(
                            (result) => {
                                let msg = result?.msg;
                                let token = result?.token;
                                if (msg == "SUCCESS") {
                                    const currentTime = new Date().getTime();
                                    dispatch(
                                        setPublicResetPasswordTime(currentTime)
                                    );
                                    setOtpButtonDisabled(true);
                                    setOtpMsg(msg);
                                    setIsGenOTP(true);
                                } else {
                                    setOtpMsg(msg);
                                }
                            }
                        );
                    }
                });
        });
    };

    const onClickVisible = () => {
        if (passwordVisible) {
            setPasswordVisible(false);
        } else {
            setPasswordVisible(true);
        }
    };

    const errors = formState.errors;

    return (
        <Container maxWidth="md">
            {/* <Notifaction fixed closedButton /> */}
            <Header
                headerTitle={t("common.sideNavList.login")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                <Box className="main">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                height: "100%",
                            }}
                        >
                            <Typography variant="h5" component="h1">
                                {t("common.portal.publicLogin")}
                                <br />
                                <br />
                            </Typography>
                            <CustomTextField
                                label={t("common.email")}
                                required={false}
                                style={{ width: "35%" }}
                                inputProps={register("email", {
                                    validate: {
                                        valid: (value) =>
                                            value.includes("@") ||
                                            "invalidEmail",
                                    },
                                    required: "emptyEmail",
                                })}
                                // type="email"
                            />

                            {errors?.email?.message && (
                                <FormHelperText>
                                    <ErrorMsg
                                        message={t(
                                            "common.login.error." +
                                                errors?.email?.message
                                        )}
                                    />
                                </FormHelperText>
                            )}
                            {otpMsg != "SUCCESS" && otpMsg != "" && (
                                <FormHelperText>
                                    <ErrorMsg
                                        message={
                                            otpMsg === "NOT_PUBLIC_USER"
                                                ? t(
                                                      "common.portal.notPublicUser"
                                                  )
                                                : otpMsg === "INCORRECT_EMAIL"
                                                ? t("errorMsg.email.rule")
                                                : null
                                        }
                                    />
                                </FormHelperText>
                            )}
                            {isGenOTP && (
                                <CustomTextField
                                    label={t("common.portal.password")}
                                    required={false}
                                    style={{ width: "35%" }}
                                    type={passwordVisible ? null : "password"}
                                    inputProps={register("password")}
                                    unit={
                                        passwordVisible === true ? (
                                            <Button
                                                onClick={onClickVisible}
                                                disableRipple={true}
                                                className={classes.eye}
                                            >
                                                <VisibilityOffIcon
                                                    style={{ color: "gray" }}
                                                />
                                            </Button>
                                        ) : (
                                            <Button
                                                onClick={onClickVisible}
                                                disableRipple={true}
                                                className={classes.eye}
                                            >
                                                <VisibilityIcon
                                                    style={{ color: "gray" }}
                                                />
                                            </Button>
                                        )
                                    }
                                />
                            )}
                            {loginMsg != "SUCCESS" && (
                                <FormHelperText>
                                    <ErrorMsg
                                        message={
                                            loginMsg === "INVALID_USER_OR_PW"
                                                ? t(
                                                      "common.portal.invalidLogin"
                                                  )
                                                : loginMsg === "EMAIL_MISSING"
                                                ? t("errorMsg.email.rule")
                                                : loginMsg === "PW_MISSING"
                                                ? t("common.portal.missingPw")
                                                : loginMsg === "NOT_PUBLIC_USER"
                                                ? t(
                                                      "common.portal.notPublicUser"
                                                  )
                                                : loginMsg === "VALIDATION_FAIL"
                                                ? t(
                                                      "common.portal.validationFail"
                                                  )
                                                : loginMsg ===
                                                      "ACCOUNT_LOCKED" ||
                                                  otpMsg === "ACCOUNT_LOCKED"
                                                ? t(
                                                      "common.login.error.accountLocked"
                                                  )
                                                : otpMsg === "COOLDOWN"
                                                ? t("common.portal.cooldown")
                                                : null
                                        }
                                    />
                                </FormHelperText>
                            )}
                            <Box>
                                {isGenOTP && (
                                    <Button
                                        className="buttons"
                                        // component={Link}
                                        variant="contained"
                                        color="primary"
                                        style={{
                                            marginRight: "10px",
                                            marginTop: "14px",
                                        }}
                                        type="submit"
                                        data-action="submit"
                                        data-sitekey="6LeWvVwdAAAAAI9JwB5OcndiYHiCA_LCISNCmTiM"
                                        data-callback="onSubmit"
                                        onClick={() => {
                                            setActionType("Login");
                                        }}
                                    >
                                        {t("common.sideNavList.login")}
                                    </Button>
                                )}
                                <Button
                                    className="buttons"
                                    variant="contained"
                                    color="primary"
                                    style={{ margin: "30px 0 15px 10px" }}
                                    type="submit"
                                    onClick={() => {
                                        setActionType("OTP");
                                    }}
                                    disabled={otpButtonDisabled}
                                >
                                    {isGenOTP
                                        ? `${t("common.portal.resendOTP")}${
                                              otpButtonDisabled && countdown > 0
                                                  ? ` ${countdown}${
                                                        i18n.language.includes(
                                                            "tc"
                                                        ) ||
                                                        i18n.language.includes(
                                                            "sc"
                                                        )
                                                            ? "秒"
                                                            : "s"
                                                    }`
                                                  : ""
                                          }`
                                        : `${t("common.portal.getOTP")}${
                                              otpButtonDisabled && countdown > 0
                                                  ? ` ${countdown}${
                                                        i18n.language.includes(
                                                            "tc"
                                                        ) ||
                                                        i18n.language.includes(
                                                            "sc"
                                                        )
                                                            ? "秒"
                                                            : "s"
                                                    }`
                                                  : ""
                                          }`}
                                </Button>
                            </Box>
                            <Box>
                                <IamsmartLoginButton
                                    onLogin={onLogin}
                                    loginMsg={loginMsg}
                                    setLoginMsg={setLoginMsg}
                                />
                            </Box>
                            <div
                                className={
                                    [
                                        "Windows Phone",
                                        "Android",
                                        "iOS",
                                    ].includes(getUserAgent())
                                        ? "general-mobile-page"
                                        : "general-page"
                                }
                            >
                                {t("reCaptcha.lng")}
                                <a
                                    href={t("reCaptcha.policyLink")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t("reCaptcha.priPolicy")}
                                </a>{" "}
                                {t("reCaptcha.and")}
                                <a
                                    href={t("reCaptcha.termsLink")}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {t("reCaptcha.terService")}
                                </a>{" "}
                                {t("reCaptcha.apply")}
                            </div>
                        </Box>
                    </form>
                </Box>
            </Box>
        </Container>
    );
}
export default LoginPublic;
